import { render } from "./LbrxPrintTicketsBox.vue?vue&type=template&id=2f70622b&scoped=true"
import script from "./LbrxPrintTicketsBox.vue?vue&type=script&lang=js"
export * from "./LbrxPrintTicketsBox.vue?vue&type=script&lang=js"

import "./LbrxPrintTicketsBox.vue?vue&type=style&index=0&id=2f70622b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f70622b"]])

export default __exports__